import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const EXPRESS_API = process.env.REACT_APP_SERVER_API;

const getTotalBlocks = async (batchName) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: EXPRESS_API,
    prepareHeaders: (headers) => {
      const token = JSON.parse(sessionStorage.getItem('tokens'))?.access_token;
      const userApiKey = JSON.parse(sessionStorage.getItem('api_key'))?.user_api_key;
      if (token) headers.set('Authorization', `Bearer ${token}`);
      if (userApiKey) headers.set('User_api_key', userApiKey);
      return headers;
    },
  });

  const validBlocks = [];

  const requests = Array.from({ length: 6 }).map(async (_, i) => {
    const result = await baseQuery(`/colourmaps/${batchName}/${i}/`, {});
    if (result.data?.colourmaps?.length > 0) {
      validBlocks.push(i);
    }
  });

  try {
    await Promise.all(requests);
    return validBlocks.length;
  } catch (err) {
    console.error('Error fetching total blocks:', err);
    return 1; // fallback
  }
};

export default getTotalBlocks;
